export const getters = {
  tratament: (state) => {
    let tratament;
    state.pacient.history.forEach((obj) => {
      !tratament &&
        (obj.dinte && obj.dinte.replace(' ', '-')) ===
          state.modalData.dinteStart &&
        (tratament = obj.denumire);
    });
    return tratament;
  },
  medici: state => {
    // we convert to array with object to be compliant with BaseCustomSelect format
    return state.medici.map(val => ({name: val}))
  }
};
